import { ID } from './id';

export enum ReminderBasedOn {
  Start = 'start',
  DayStart = 'dayStart',
  // Start + the timeslot's duration. No picker offers it; it exists so a stored `end` survives a read and a save (OQ-31).
  End = 'end',
}

export type Reminder = {
  id?: ID | null;
  offset: number;
  basedOn: ReminderBasedOn;
};
